import React, { useState } from 'react';
import Modal from 'react-modal';
import Dialog from 'components/Dialog';
import Button from 'components/Button';
import Link from 'components/Link';
import BoxBody from 'components/BoxBody';
import Text from 'components/Text';

export type Props = {
  children: (props: { onClick: () => void }) => React.ReactElement;
};

export default function FreeAnnouncementRateLimit(props: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {props.children({ onClick: () => setIsOpen((open) => !open) })}
      <Modal isOpen={isOpen}>
        <Dialog
          title="The Remind subscription for your district has expired."
          onRequestHide={() => setIsOpen(false)}
          size="xxsmall"
        >
          <BoxBody>
            <Text color="graphite" element="p" align="left">
              You no longer have access to messaging as your district has upgraded to ParentSquare,
              an all-in-one platform designed to streamline communication and engagement with
              families. Please check with your administrator for details on how to get started! For
              any questions or more information, contact your school or district administrator
              directly.
            </Text>

            <Button full color="mascot" onClick={() => setIsOpen(false)}>
              Done
            </Button>
          </BoxBody>
        </Dialog>
      </Modal>
    </>
  );
}
